import * as React from "react";
import { $, merge } from "glamor";
import { Dialog } from "components/dialog";
import Close from "components/icons/close";
import theme from "styles/theme";
import { ProductDetails } from "./product-details";
import { List } from "immutable";
import { productsInAssortment, IDisplayFields } from "helpers/product-collection";
import { DATATEST } from "constants/integration";

interface IProps {
    merchantId: string;
    productId: string;
    onFetchGlobalProducts: (params) => void;
    globalProducts: List<any>;
    globalProductsIsFetching?: boolean;
    onSelectColorVariant: (prod: { _id: string }) => void;
    router: any;
    onAddItem: (prod: { _id: string }) => void;
    itemDisplayProperty: List<any>;
    modalOpen: boolean;
    onRequestClose: () => void;
    brandEntities: any;
    items: List<any>;
    editable: boolean;
    shopViewFields: IDisplayFields;
    readOnly?: boolean;
}

export const ProductDetailsModal: React.FunctionComponent<IProps> = ({
    onRequestClose,
    modalOpen,
    merchantId,
    productId,
    onFetchGlobalProducts,
    globalProducts,
    globalProductsIsFetching,
    onSelectColorVariant,
    router,
    onAddItem,
    itemDisplayProperty,
    brandEntities,
    items,
    editable,
    shopViewFields,
    readOnly,
}) => {
    const inAssortmentProducts = React.useMemo(() => {
        return productsInAssortment(items);
    }, [items]);

    const modalActionsStyles = React.useMemo(() => {
        return merge(
            $(".actions", {
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-end",
                margin: "0 20px !important",
                padding: "10px 0 !important",
            }),
            $(".actions > svg", {
                cursor: "pointer",
                fill: `${theme.palette.darkGrey} !important`,
                height: "30px !important",
                width: "30px !important",
            }),
            $(" .iconActions", {
                marginLeft: "10px",
                padding: "2px",
            }),
            $(" .divider", {
                backgroundColor: "#e1e1e1",
                height: "26px",
                margin: "11px 8px 12px",
                width: "1px",
            })
        );
    }, []);

    const muiStyles = React.useMemo(() => {
        return {
            customContentStyle: {
                width: "98%",
                maxWidth: "1200px",
            },
        };
    }, []);

    return (
        <React.Fragment>
            <Dialog
                onRequestClose={onRequestClose}
                open={modalOpen}
                autoScrollBodyContent={true}
                contentStyle={muiStyles.customContentStyle}
                modal={false}
                repositionOnUpdate={false}
                bodyStyle={{ borderTop: undefined }}
                showCloseButton={false}
                style={{ zIndex: "9999", paddingTop: "16px" }}
                title={
                    <div {...modalActionsStyles} className="actions">
                        <React.Fragment>
                            <div className="divider" />
                            <Close
                                data-test={DATATEST.ASSORTMENTS.DETAILS_CLOSE_BTN}
                                key="close"
                                onClick={onRequestClose}
                                color={theme.palette.darkerGrey}
                            />
                        </React.Fragment>
                    </div>
                }
            >
                <ProductDetails
                    merchantId={merchantId}
                    productId={productId}
                    onFetchGlobalProducts={onFetchGlobalProducts}
                    globalProducts={globalProducts}
                    globalProductsIsFetching={globalProductsIsFetching}
                    onSelectColorVariant={onSelectColorVariant}
                    inAssortmentProducts={inAssortmentProducts}
                    router={router}
                    onAddItem={onAddItem}
                    itemDisplayProperty={itemDisplayProperty}
                    brandEntities={brandEntities}
                    editable={editable}
                    shopViewFields={shopViewFields}
                    readOnly={readOnly}
                />
            </Dialog>
        </React.Fragment>
    );
};
